import * as React from 'react'
import styled from 'styled-components'

import * as entity from '@boutique/entities'
import * as richtext from '@boutique/rich-text'

import * as plume from '@ulule/owl-kit-components/next'

type SizeGuideProps = {
  product: entity.product.Product
}
export function SizeGuide({ product }: SizeGuideProps): React.ReactElement<SizeGuideProps> | null {
  if (!('identifier' in product.brand)) {
    // This is to verify if brand is SlimColdUnmatchedBrand
    return null
  } else {
    if (product.sizeGuideImage !== null || product.sizeGuideText !== null) {
      return (
        <OverflowWrapper>
          {product.sizeGuideText !== null && (
            <SizeGuideParagraph as={'pre'}>{product.sizeGuideText}</SizeGuideParagraph>
          )}
          {product.sizeGuideImage !== null && <SizeGuidePicture src={product.sizeGuideImage} />}
        </OverflowWrapper>
      )
    } else if (product.brand.sizeGuide !== null) {
      return <richtext.RichText document={product.brand.sizeGuide.json} links={product.brand.sizeGuide.links} />
    }
  }

  return <></>
}

const OverflowWrapper = styled.div`
  overflow: auto;
`

const SizeGuidePicture = styled(plume.Picture)`
  width: 100%;
`

const SizeGuideParagraph = styled(plume.styles.wysiwyg.Paragraph)`
  white-space: pre-wrap;

  font-size: 18px;
  line-height: 150%;
  font-weight: 300;
  margin: 20px 0;
`
